import * as React from "react";

function WishlistProductExistsPopup(props: {
	overwriteWishlistProduct: () => void,
	combineWishlistProducts: () => void,
	handleClose: () => void
}) {
	const dialogElement = React.useRef(null);
	React.useEffect(() => {
		openPopup();
	}, []);

	function closePopup() {
		props.handleClose();
		dialogElement.current.close();
	}

	function openPopup() {
		dialogElement.current.showModal();
	}

	return (
		<dialog ref={dialogElement} className="c-dialog js-basket-wishlist-product-exists-popup" data-test="basket-wishlist-product-exists-popup">
			<div className="c-dialog__content">
				<h1 className="c-dialog__title u-mb20">Product already in wishlist</h1>
				<div className="c-cms u-mb20">
					<p>This product is already in your wishlist. Would you like to keep both and combine the quantities, or overwrite the wishlist quantity with the quantity currently in your basket?</p>
				</div>
				<div className="c-dialog__actions">
					<button type="button" className="c-button" data-test="basket-wishlist-product-exists-popup-combine-button" onClick={props.combineWishlistProducts}>Combine <span className="u-visuallyhidden">product quantity with product already in wishlist</span></button>
					<button type="button" className="c-button c-button--outline" data-test="basket-wishlist-product-exists-popup-overwrite-button" onClick={props.overwriteWishlistProduct}>Overwrite <span className="u-visuallyhidden">wishlist product quantity with current basket quantity</span></button>
				</div>
			</div>
			<button className="c-dialog__close" type="button" data-test="basket-wishlist-product-exists-popup-close-button" onClick={closePopup}><span className="u-visuallyhidden">Close overlay</span></button>
		</dialog>
	)
}
export default WishlistProductExistsPopup;
